﻿import axios from 'axios';
import Cookies from 'js-cookie';
import { authentication } from '../components/user-access/Authentication';

const ApiService = axios.create({
    timeout: 30000
});

ApiService.interceptors.request.use(function (config) {
    config.baseURL = window.env.API_URL;
    var isIE = !!window.MSInputMethodContext && !!document.documentMode;

    if (isIE) {
        config.headers.Pragma = 'no-cache';
    }


    var authConfig = authentication.getAccessToken();
    if (authConfig != null) {
        config.headers.Authorization = `Bearer ${authConfig.accessToken}`;
    }
    
    if (window.env.DEVELOP_MODE === "true" && config.url.includes(`/${window.env.DEVELOP_SERVICE}/`)) {
        config.baseURL = 'https://localhost:44342';
        config.url = config.url.replace(`/${window.env.DEVELOP_SERVICE}/`, '/');
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

ApiService.interceptors.response.use(function (response) {
    return response;
}, function (error) {
        const status = error.response ? error.response.status : null
        const originalRequest = error.config;

        const unauthorized = 401;
        const onHold = 402;
        const sessionSuperseded = 412; // session evicted by a newer sign-in on the same frontend
        const noActiveSession = 419;   // no session for this frontend (signed out / stale cache / first hop)

        switch (status) {
            case unauthorized:
                return new Promise(function (resolve, reject) {
                    authentication.run(() => {
                        ApiService(originalRequest).then(function (response) {
                            resolve(response);
                        }, function (err) {
                            reject(err);
                        });
                    });
                });
            // 412: this session was superseded by a newer sign-in on the same frontend (or the account was
            // disabled). SSO/federated users (identified by the 'sso' cookie) cannot be forced to
            // re-authenticate — B2C would silently reclaim them via the upstream IdP — so we eject them to the
            // logged-out landing page for THIS app only, preserving the shared B2C session. Local accounts get
            // an interactive re-login (prompt=login). Either way we deliberately avoid a global B2C sign-out,
            // which would sign the user out of their other Vision apps.
            case sessionSuperseded:
                if (Cookies.get('sso') != null) {
                    authentication.ejectSupersededSession();
                } else {
                    authentication.forceLogin();
                }
                return Promise.reject(error);
            // 419: there is no session to compete with (signed out elsewhere, stale cached token, or first
            // cross-app hop). Silently re-authenticate via the existing B2C SSO session — no prompt, no logout.
            case noActiveSession:
                authentication.rechallenge();
                return Promise.reject(error);
            case onHold:
                authentication.onHoldRedirect();
                return Promise.reject(error);
            default:
                return Promise.reject(error);
        }
       
});


export default ApiService;